import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { borderStyleGray } from "../../reportingHelpers.jsx";

const signatureCellStyle = {
  flexDirection: "column",
  border: borderStyleGray,
  padding: 3,
  height: 45,
  justifyContent: "space-between",
  fontSize: 10,
};

const ShootoutOfficials = ({ roles = [], homeTeamId, awayTeamId }) => {
  const safePrintName = (role) => role?.name ?? "-";
  const findRole = (roleName) => roles.find((r) => r.role === roleName);

  const homeManager = roles.find((r) => r.role === "MANAGER" && r.entityId === homeTeamId);
  const awayManager = roles.find((r) => r.role === "MANAGER" && r.entityId === awayTeamId);
  const umpire1 = roles.find((r) => r.role === "UMPIRE" && r.number === 1);
  const umpire2 = roles.find((r) => r.role === "UMPIRE" && r.number === 2);
  const technicalOfficer = findRole("TECHNICAL_OFFICIAL");

  return (
    <View style={{ marginTop: 8 }}>
      <Text
        style={{
          textAlign: "center",
          fontSize: 12,
          fontWeight: "bold",
          marginBottom: 4,
        }}
      >
        Signatures
      </Text>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <View style={{ ...signatureCellStyle, flexBasis: "49%" }}>
          <Text style={{ fontSize: 8 }}>Team Manager</Text>
          <Text>{safePrintName(homeManager)}</Text>
        </View>
        <View style={{ ...signatureCellStyle, flexBasis: "49%" }}>
          <Text style={{ fontSize: 8 }}>Team Manager</Text>
          <Text>{safePrintName(awayManager)}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 5,
        }}
      >
        <View style={{ ...signatureCellStyle, flexBasis: "49%" }}>
          <Text style={{ fontSize: 8 }}>Umpire</Text>
          <Text>{safePrintName(umpire1)}</Text>
        </View>
        <View style={{ ...signatureCellStyle, flexBasis: "49%" }}>
          <Text style={{ fontSize: 8 }}>Umpire</Text>
          <Text>{safePrintName(umpire2)}</Text>
        </View>
      </View>
      <View style={{ alignItems: "center", marginTop: 5 }}>
        <View style={{ ...signatureCellStyle, width: "50%" }}>
          <Text style={{ fontSize: 8 }}>Technical Officer</Text>
          <Text>{safePrintName(technicalOfficer)}</Text>
        </View>
      </View>
    </View>
  );
};

export default ShootoutOfficials;
